import csrfToken from "../../common/helpers/csrf-token";
import * as EventListener from "../../common/helpers/event-listener";
import { makeFilterUrl } from "../../common/helpers/helper";

const wishlistPagination = () => {
    EventListener.click("wish-list-pagination-button", (button) => {
        const page = button.getAttribute("data-page");

        let requestData = {};

        if (parseInt(page) !== 1) {
            requestData = { ...requestData, page };
        }

        makeFilterUrl(requestData);

        oc.ajax("Settings::onAjax", {
            data: {
                _token: csrfToken,
                page,
            },
            loading: "#loader-line",
            update: { "catalog/wishlist/wishlist": ".wish-list-wrapper" },
            complete: () => {
                window.scrollTo(0, 0);
            },
        });
    });
};

wishlistPagination();
